module.exports = __webpack_public_path__ + "static/media/form.c2825947.png";